/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const GuideIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="GuideIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              d="M8 4.5C9 3 10 2.5 12 2.5L13.0003 2.50002C13.2764 2.50002 13.5 2.72388 13.5 3.00002V11C13.5 11.2762 13.2763 11.5 13.0001 11.5H12C10 11.5 9 12.5 8 13.5M8 4.5V13.5M8 4.5C7 3 6 2.50004 4 2.50004H2.99969C2.72355 2.50005 2.5 2.7239 2.5 3.00004V11.0001C2.5 11.2762 2.72373 11.5001 2.99987 11.5001H4C6 11.5 7 12.5 8 13.5"
              stroke="currentColor"
              strokeLinejoin="round"
            />
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

GuideIcon.tags = [
  'book',
  'how to',
  'instructions',
  'library',
  'read',
  'manual',
  'document',
  'guide',
  'textbook',
];

GuideIcon.category = 'General Icons';

GuideIcon.iconSize = 16;
